class ActivePolylineSubject {
  observers = []

  activePolyline = { action: null, value: null } // Actions: switch > click > hover

  attach(observer) {
    this.observers.push(observer)
    observer([this.activePolyline.value])
  }

  detach(observerToRemove) {
    this.observers.filter((observer) => observerToRemove !== observer)
  }

  notify(activePolyline) {
    let hoveredPolyline = null
    if (activePolyline.action === "switch") {
      this.activePolyline = activePolyline
    } else if (this.activePolyline.value !== "all") {
      if (activePolyline.action === "click") {
        this.activePolyline = activePolyline
      } else if (activePolyline.action === "hover") {
        hoveredPolyline = activePolyline
      }
    }
    this.observers.forEach((observer) =>
      observer([
        this.activePolyline.value,
        hoveredPolyline && hoveredPolyline.value,
      ])
    )
  }
}

const activePolylineSubject = new ActivePolylineSubject()

export default activePolylineSubject
